import {Pipe, PipeTransform} from '@angular/core';
import {AvReferenzNummerListEntry} from "../../../core/av-api";
import {FormatAvReferenzNummerPipe} from "./format-av-referenz-nummer.pipe";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'formatAvReferenznummern'
})
export class FormatAvReferenzNummernPipe implements PipeTransform {

  constructor(private formatAvReferenzNummer: FormatAvReferenzNummerPipe, private translate: TranslateService) {
  }

  transform(values: Observable<AvReferenzNummerListEntry[]>): Observable<string> {
    return values.pipe(map(a => a.map(item => this.formatAvReferenzNummer.transform(item))), map(a => a.join(', ')),
      map(a => a ? a : this.translate.instant('Keine')));
  }
}
